<template>
  <div class="container">
    <b-alert class="border border-dark w-100 my-4" show variant="danger">
      <h4 class="alert-heading">
        {{ getContentItem("error") }}
      </h4>
      <p
        class="my-4"
      >
        {{ format(getContentItem("quoteMessageSendError"), tenantDetails.SupportPhoneNumber) }}
      </p>
      <p v-if="errorMessage">
        {{ errorMessage }}
      </p>
    </b-alert>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { stringHelper } from "@/components/mixins/stringHelper";

  export default {
    name: "SendError",
    computed: {
      ...mapGetters(["getContentItem", "tenantDetails"])
    },
    mixins: [stringHelper],
    props: {
      errorMessage: {
        type: String,
        required: false
      }
    }
  };
</script>
